import { OAuthConfig } from '@doka/identity-login';

export const environment = {
  production: false,
  stage: 'test',
  baseUrlGroupIdentityAPI: 'https://login.doka.com',
  apiBaseUrl: 'https://azwe-app-test-invest.azurewebsites.net',
};

export const authCodeFlowConfig: OAuthConfig = {
  issuer: 'https://login.doka.com',
  strictDiscoveryDocumentValidation: false,
  clientId: '8bf08ac9-4ff1-4098-8e62-a0669702743e',
  responseType: 'code',
  scope: 'openid profile email offline_access investtool.doka.com/invest',
  oidc: true,
  showDebugInformation: true,
  logoutUrl: 'https://login.doka.com/connect/endsession',
  tokenEndpoint: 'https://login.doka.com/connect/token',
  redirectUri: `${window.location.origin}/authentication/callback`,
  silentRefreshRedirectUri: `${window.location.origin}/authentication/silent-callback`,
};
